<template>
  <div class="list" v-if="arraydata.length > 0">
    <div class="list-item" v-for="(item, index) in arraydata" :key="index" @click="itemClick(item)">
      <div class="left">
        <div :style="{width:'32px',height:'32px'}">
          <van-image round width="32px" height="32px" :src="
            item.userInfo === null ||
            item.userInfo.head_img_url === null ||
            item.userInfo.head_img_url === ''
              ? headerUrl
              : item.userInfo.head_img_url
          "></van-image>
        </div>
        <div>
          <div class="userInfo_box">
            <div class="userInfo">
              <div class="nickName">{{item.userInfo === null || item.userInfo.nick === null || item.userInfo.nick === "" ? "" : item.userInfo.nick.substring(0,15)}}</div>
              <div class="topIcon" v-if="item.top === 1">
                <img src="../assets/img/commTop_icon.png" alt="">
              </div>
            </div>
            <div class="date">{{ timestampToTime(item.comment_time) }}</div>
            <!-- <van-tag v-show="item.top === 0" color="#2EBA73" text-color="#2EBA73">置顶</van-tag> -->
          </div>
        </div>
      </div>
      <div class="right">
        <p style="width:32px;heihgt:32px;"></p>
        <div>
          <div class="right_content">{{ item.content }}</div>
          <div class="images" v-if="item.image !== null && item.image.length !== 0">
            <div v-for="(x, i) in item.data.imagesRet" :key="i">
              <van-image v-if="x.checkRet == 0 || userId == item.uid" :src="x.data" width="32vw" height="96px" fit="cover" @click.stop="scaleAttrsImg(item.data.imagesRet, i,item)"></van-image>
              <!-- <van-image v-else :src="''" width="32vw" height="96px" fit="cover" @click.stop="scaleAttrsImg(item.data.imagesRet, i,item)"></van-image> -->
            </div>
          </div>
          <div class="time-num">
            <!-- <p>{{ timestampToTime(item.comment_time) }}</p> -->
            <div class="time">

              <div class="comment_delete" v-if="isVisalbeDelBtn && item.uid == uid " @click="CommentDelete(item.comment_id, 1)">
                删除
              </div>
            </div>

            <div class="num-box">
              <div v-if="isShowReplay">
                <van-image :src="discussNum" width="16px" height="16px" @click.stop="itemReply(item,item.comment_id)"></van-image>
                {{ item.reply_count?item.reply_count:'' }}
              </div>
              <div>
                <van-image v-if="!item.is_up" :src="zanNum" width="16px" height="16px" :disabled="isCanUp" @click.stop="itemDianZan(item, item.comment_id)"></van-image>
                <van-image v-if="item.is_up" :src="zanNumAct" width="16px" height="16px" @click.stop="()=>{return false}"></van-image>
                {{ item.up?item.up:'' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


import { timestampToTimeForActivity } from '../common/common'
//自定义listview，左图右文
export default {
  name: "customlistview",
  props: {
    arraydata: {
      type: Array,
      default: () => [],
    },
    isVisalbeDelBtn: {
      type: Boolean,
      default: false,
    },
    isCanUp: {
      type: Boolean,
      default: false,
    },
    uid: {
      type: String,
      default: ''
    },
    propF: {},
    // 是否显示回复图标
    isShowReplay: {
      type: Boolean,
      default: () => { return true }
    }
  },
  data() {
    return {
      discussNum: require("../assets/iconImage/ic_talk@3x.png"),
      zanNum: require("../assets/iconImage/ic_like@3x.png"),
      zanNumAct: require("../assets/img/commentLike_icon.png"),
      headerUrl: require("../assets/iconImage/my_moren@3x.png"),
      userId: this.$cookie.get('w_uid'),
    };
  },
  created() {
    console.log(this.isShowReplay, 'isShowReplay')
  },
  methods: {
    itemClick(item) {
      this.$emit("itemClick", item);
    },

    itemReply(item, commId) {
      this.$emit("itemReply", item, commId)
    },

    scaleAttrsImg(item, i, dataItem) {
      this.$emit("bigPictureLook", item, i, dataItem);
    },

    CommentDelete(id, type) {
      this.$emit("commentDelete", id, type);
    },

    itemDianZan(item, id) {
      this.$emit("itemDianZan", item, id);
    },
    timestampToTime(row) {
      return timestampToTimeForActivity(row, 'commentList');
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
/deep/.van-image__error {
  i {
    display: none;
  }
}
.list {
  .list-item {
    margin-bottom: 10px;
    .left {
      display: flex;
      justify-content: space-between;
      align-content: center;

      & > div {
        width: 100%;
        .userInfo_box {
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          .userInfo {
            display: flex;
            .nickName {
              // max-width: calc(100% - 50px);
            }

            img {
              width: 30px;
              height: 16px;
              margin-left: 4px;
              // transform: translateY(0px);
            }
            // justify-content: center;
          }
          .nickName {
            font-size: 12px;
            color: #2eba73;
            overflow: hidden;
            white-space: nowrap;
          }
          .date {
            font-size: 12px;
            color: #bfbfbf;
            margin-top: 3px;
          }
        }
      }
    }
    .right {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-content: center;
      .right_content {
        word-wrap: break-word;
        table-layout: fixed;
        word-break: break-all;
        font-size: 13px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      & > div {
        width: 87.8%;
        & > p {
          font-size: 15px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: rgba(55, 56, 77, 1);
          line-height: 23px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
        }
        .images {
          margin-top: 15px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          /deep/ .van-image {
            margin-right: 3px;
            margin-bottom: 4px;
            &:nth-of-type(3n) {
              margin-right: 0px;
            }
          }
          /deep/ .van-image__img {
            border-radius: 2px;
          }
        }
        .time-num {
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          //   & > p {
          //     font-size: 12px;
          //     font-family: PingFangSC-Regular, PingFang SC;
          //     font-weight: 400;
          //     color: rgba(153, 153, 153, 1);
          //     line-height: 12px;
          //   }
          .time {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            & > p {
              &:nth-of-type(1) {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                margin-right: 15px;
              }
              &:nth-of-type(2) {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(25, 131, 92, 1);
              }
            }
          }
          .num-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            & > div {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-left: 8px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
              /deep/ .van-image {
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
}
.comment_delete {
  margin-left: 15px;
  color: #2eba73;
}
</style>
